import React from 'react';
import { mergeOverrides } from 'baseui';
import { Modal as BaseUIModal } from 'baseui/modal';
import { ModalHeader, ModalBody, ModalFooter } from './components';
import { HeadingMedium } from 'baseui/typography';
import { acOverrides } from './modal-overrides.const';
import { ModalProps } from './modal-props.interface';
import { MODAL_POISITION } from './modal-position.const';
import { useStyletron } from 'baseui';
import { ButtonV2 } from '../../ui/button';
import { useIsMobile } from '../../ui/shared-hooks/useIsMobile';

export const Modal: React.FC<ModalProps> = ({
  position = MODAL_POISITION.centered,
  title,
  content,
  primaryAction,
  secondaryAction,
  kind = 'primary',
  ...props
}) => {
  const { overrides, ...rest } = props;
  const [_, theme] = useStyletron();
  const isMobile = useIsMobile();
  const modalOverrides = mergeOverrides(
    acOverrides(position, kind, isMobile),
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    overrides
  );

  return (
    <BaseUIModal overrides={modalOverrides} {...rest}>
      {title && (
        <ModalHeader>
          <HeadingMedium
            overrides={{
              Block: {
                style: () => {
                  return {
                    display: 'flex',
                  };
                },
              },
            }}
          >
            {title}
          </HeadingMedium>
        </ModalHeader>
      )}
      <ModalBody>{content}</ModalBody>
      {(primaryAction || secondaryAction) && (
        <ModalFooter $theme={theme}>
          {primaryAction && (
            <ButtonV2
              variant='default'
              variantStyle='primary'
              size='small'
              className='font-bold'
              loading={primaryAction?.isLoading}
              onClick={primaryAction.onClick}
              disabled={primaryAction.disabled}
            >
              {primaryAction.title}
            </ButtonV2>
          )}
          {secondaryAction && secondaryAction}
          {/* {secondaryAction && (
            <ButtonV2
              variant="default"
              variantStyle="primary"
              size="small"
              className="font-bold"
              loading={primaryAction?.isLoading}
              onClick={secondaryAction?.onClick}
              disabled={secondaryAction?.disabled}
            >
              {secondaryAction.title}
            </ButtonV2>
          )} */}
        </ModalFooter>
      )}
    </BaseUIModal>
  );
};
